import { Box, Typography } from '@mui/material';
import commaNumber from 'comma-number';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { createTheme } from '@mui/material/styles';
import { AdminHeader } from '../AdminHeader/AdminHeader';
import secureLocalStorage from 'react-secure-storage';
import { createMRTColumnHelper } from 'material-react-table';
import CummonTable from '../../Common/CummonTable';
import FetchLoading from '../../Loading/FetchLoading';

const AllBooking = () => {
  const navigate = useNavigate();
  const aminInfo = secureLocalStorage.getItem('admin-info');
  let token = aminInfo?.token;
  const [isLoading, setIsLoading] = useState(true);
  const [queuesData, setQueuesData] = useState([]);
  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor('bookingId', {
      header: 'BookingId',
      Cell: ({ row }) => (
        <button
          style={{
            background: 'var(--primary-color)',
            borderRadius: '5px',
            padding: '2px 10px',
            width: '120px',
            cursor: 'pointer',
            border: 'none',
            color: 'var(--white)',
          }}
          disabled={row.original.status === 'Cancelled' ? true : false}
          onClick={() => sendToQueuesDetails(row.original)}
        >
          {row.original.bookingId}
        </button>
      ),
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      Cell: ({ row }) => (
        <Box className={`${row.original.status?.toLowerCase()}-btn`}>
          {row.original.status}
        </Box>
      ),
    }),
    columnHelper.accessor('triptype', {
      header: 'Trip Type',
      size: '10px',
    }),
    columnHelper.accessor('pnr', {
      header: 'PNR',
      size: 40,
    }),
    columnHelper.accessor('carrier', {
      header: 'Carrier',
      size: 200,
    }),
    columnHelper.accessor('depfrom', {
      header: 'From-To',
      Cell: ({ row }) => ` ${row.original.depfrom} - ${row.original.arrto}`,
    }),
    columnHelper.accessor('totalpax', {
      header: 'pax',
      size: 20,
      Cell: ({ row }) => {
        return <Box pl={2}>{row.original.totalpax}</Box>;
      },
    }),

    columnHelper.accessor('flightdate', {
      header: 'Depart Date',
      size: 20,
      Cell: ({ row }) =>
        `${
          row.original?.flightdate !== '' || 'undefined' || null
            ? format(new Date(row.original?.flightdate), 'dd MMM yy hh:mm')
            : 'Fly Date'
        }`,
    }),
    columnHelper.accessor('created_at', {
      header: 'Booking Date',
      Cell: ({ row }) =>
        `${
          row.original?.created_at !== '' || 'undefined' || null
            ? format(new Date(row.original?.created_at), 'dd MMM yy hh:mm')
            : 'Booked Date'
        }`,
    }),

    columnHelper.accessor('name', {
      header: 'Passenger Name',
    }),
    columnHelper.accessor('grossfare', {
      header: 'Total Fare',
      Cell: ({ row }) =>
        `${commaNumber(row.original.grossfare) + 'AED' || 'Gross Cost'}`,
    }),
  ];

  useEffect(() => {
    const fetchQueuesData = () => {
      setIsLoading(true); // Set loading to true before the fetch

      fetch(`https://api-b2b.businesssolutions.ae/admin/booking`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          setQueuesData(data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    fetchQueuesData();
  }, [token]);

  const sendToQueuesDetails = (items) => {
    navigate(`/dashboard/bookingdetails/${items?.uid}`, {
      state: {
        data: items,
      },
    });
  };
  console.log(queuesData);
  return (
    <Box>
      <AdminHeader />

      <Box sx={{ p: 2, boxSizing: 'border-box' }}>
        <Typography
          variant="span"
          sx={{
            fontWeight: 400,
            fontSize: '24px',
            color: '#222222',
            pb: 1,
          }}
        >
          All Booking
        </Typography>
        {!isLoading ? (
          <CummonTable data={queuesData} columns={columns} pageSize={15} />
        ) : (
          <FetchLoading />
        )}
      </Box>
    </Box>
  );
};

export default AllBooking;
